export const composeAttributeFilterId = (
  filterId: string,
  filterSlug?: string,
): string => (filterSlug ? `${filterSlug}-${filterId}` : filterId);
